module.exports = __webpack_public_path__ + "static/media/button_plus_dark.1b370460.svg";